import type { ReactNode } from "react";
import { Search20Regular } from "@fluentui/react-icons";

interface ListToolbarProps {
  filter: string;
  onFilterChange: (value: string) => void;
  placeholder?: string;
  // Compact summary (counts/totals) shown next to the filter so the header is one
  // cohesive band instead of a lonely card + a far-away button.
  summary?: ReactNode;
  // The primary action(s) for the list (e.g. "+ Novo …"), right-aligned.
  children?: ReactNode;
}

// Uniform list header shared by every obra list tab: an instant filter-as-you-type
// box + the summary on the left, and the list's primary action(s) on the right.
// Keeps the filter affordance, the summary, and the action button identical across tabs.
export function ListToolbar({
  filter,
  onFilterChange,
  placeholder = "Filtrar…",
  summary,
  children,
}: ListToolbarProps) {
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-3 flex-wrap flex-1" style={{ minWidth: 200 }}>
        <div
          className="flex items-center gap-2 border border-border bg-background"
          style={{ borderRadius: "var(--radius)", paddingLeft: 10, minWidth: 180, flex: "0 1 320px" }}
        >
          <Search20Regular className="w-4 h-4 text-secondary-text" style={{ flexShrink: 0 }} />
          <input
            type="text"
            value={filter}
            onChange={(event) => onFilterChange(event.target.value)}
            placeholder={placeholder}
            aria-label={placeholder}
            className="flex-1 py-2 bg-transparent outline-none text-foreground text-sm"
            style={{ minWidth: 80 }}
          />
          {filter !== "" && (
            <button
              type="button"
              onClick={() => onFilterChange("")}
              aria-label="Limpar filtro"
              className="px-2 text-secondary-text hover:text-foreground cursor-pointer text-sm"
              style={{ flexShrink: 0 }}
            >
              ✕
            </button>
          )}
        </div>
        {summary && (
          <div className="flex items-center gap-3 flex-wrap">{summary}</div>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-2 flex-shrink-0 flex-wrap justify-end">
          {children}
        </div>
      )}
    </div>
  );
}
